
<template lang="pug">
q-page.fit
  .absolute-full.column

    //- ツールバー
    .col-auto
      .flex.justify-between
        .flex.items-center.q-ma-xs

          //- q-btn.q-mx-xs(
          //-   flat
          //-   @click="onClickMakeDailies"
          //- ) 初期化

          q-btn.q-mx-xs(
            flat
            @click="onClickPrint"
          ) 印刷

        .flex.items-center.justify-end.q-ml-auto.q-mr-xs

          //- 現在のカーソルが指す位置の勤務時刻情報
          .q-mx-xs {{currentInfo}}

    //- グリッド
    .col.grid
      .grid__table(
        v-show="showGrid"
        ref="table"
        :style="gridTableStyle"
        @mousedown.left.stop="onMouseDownLeft"
      )
        .grid__thead

          //- コーナー
          .grid__corner-area(@contextmenu.prevent)
            .grid__tr
              .grid__corner(:style="cornerStyle0") 月
            .grid__tr
              .grid__corner(:style="cornerStyle0") 日
            .grid__tr
              .grid__corner(:style="cornerStyle0") 曜日

          //- 列ヘッダ
          .grid__column-header-area(
            @contextmenu.prevent
            @dblclick="onHeaderDoubleClick"
          )
            .grid__column-header-cursor(:style="gridColumnHeaderCursorStyle")
            .grid__tr
              .grid__column-header(
                v-for="col in cols"
                :style="colHeaderStyle0"
              ) {{col.textMonth}}
            .grid__tr
              .grid__column-header(
                v-for="col in cols"
                :style="colHeaderStyle0"
              ) {{col.textDate}}
            .grid__tr
              .grid__column-header.dailies__column-header-week(
                v-for="col in cols"
                :style="[colHeaderStyle0, col.style]"
                :class="{'dailies__week--holiday': col.timeIndex === 7}"
              ) {{col.textWeek}}

        //- 行ヘッダ
        .grid__row-header-area(@contextmenu.prevent)
          .grid__row-header-cursor(:style="gridRowHeaderCursorStyle")
          .grid__tr(v-for="row of rows")
            .grid__row-header.grid__left(:style="rowHeaderStyle0") {{row.text}}
            .grid__row-header.grid__center(:style="rowHeaderStyle1") {{row.textTime}}

            //- daily_people情報が作成されたが、退職でpeopleから削除されている場合、個人勤務予定表メニューは表示しない
            ContextMenu2(@beforeShow="onRowHeaderContext" v-if="people[row.person_code] != null")

        //- セル
        .grid__cell-area(
          @dblclick="onCellDoubleClick"
          @mousedown.left.stop="onCellMouseDownLeft"
        )
          .grid__cell-cursor(:style="gridCellCursorStyle")
          grid-cells(
            :grid="grid"
            :rows="rows"
          )

          ContextMenu2(@beforeShow="onCellContext")

  //- 出退勤時間の入力
  PopupTimeRange(
    ref="popupTimeRange"
    :min="store.display_begin_time"
    :max="store.display_end_time"
    @confirm="timeRangeConfirm"
  )
    template(slot-scope="{params: {regular}}")
      q-btn.q-mx-sm(
        color="secondary"
        flat
        @click="timeRangeOff"
      ) 休み

      q-btn.q-mx-sm(
        v-if="regular"
        color="secondary"
        flat
        @click="timeRangeRegular"
      ) 通常 {{regular.begin|time}}〜{{regular.end|time}}


  //- 個人予定表ダイアログ
  PopupSchedule(ref="popupSchedule")
</template>

<script>
import {addDays} from 'date-fns/esm'
import {get} from 'lodash-es'

import {dateToObject, dateToString, dateFilter, timeIsValid, isEqualOrBefore, weeks} from 'helpers/date'
import {mapAuto} from 'helpers/vuex-bind'
import Person from 'models/Person'
import DailyPerson from 'models/DailyPerson'

import ContextMenu from 'components/ContextMenu'
import PopupTimeRange from 'components/PopupTimeRange'
import AxiosMixin from 'mixins/axios'
import GridMixin from 'mixins/GridMixin'

import PopupSchedule from 'components/PopupSchedule'

const STATUS_OFF             = '◯'
const STATUS_REGULAR         = '　'
const STATUS_IRREGULAR       = '　'
const STATUS_IRREGULAR_OFF   = '◯'
const STATUS_IRREGULAR_COLOR = '#ffff0080'

export default {
  components: {ContextMenu, PopupTimeRange, PopupSchedule},
  mixins: [AxiosMixin, GridMixin],

  props: {
    storeCode: String,
    floorCode: String,
    beginDate: String,
  },

  data() {
    return {
      grid: {
        cellW:     25,
        cellH:     25,
        headerW:  130,
        headerH:   25 * 3,
        paddingW:  20,
        paddingH:  20,
      },

      people: {},
      dailyPeople: {},
    }
  },

  computed: {
    ...mapAuto(['stores', 'holidays', 'daysPerPeriod']),

    cornerStyle0()    {return {...this.gridCornerStyle,       height: '25px'}},
    colHeaderStyle0() {return {...this.gridColumnHeaderStyle, height: '25px'}},
    rowHeaderStyle0() {return {...this.gridRowHeaderStyle,    width:  '60px'}},
    rowHeaderStyle1() {return {...this.gridRowHeaderStyle,    width:  '70px'}},

    viewKey() {
      return Object.values(this.$props).some(v => v == null)
        ? null
        : this.storeCode + '/' + this.floorCode + '/' + this.beginDate
    },

    store() {
      return this.stores.find(store =>
        store.store_code == this.storeCode &&
        store.floor_code == this.floorCode) || {}
    },

    currentInfo() {
      const {x, y} = this.grid.cursor
      const row = this.rows[y]
      if(row != null) {
        const cell = row.cells[x]
        if(cell != null) {
          return row.name + ' ' + dateFilter(cell.date) + ' '
            + (get(this.dailyPeople, [cell.id, 'timeLabel']) || '休み　　　　')
        }
      }
      return ''
    },

    beginDateObject() {
      return dateToObject(this.beginDate)
    },

    endDateObject() {
      return addDays(this.beginDateObject, this.daysPerPeriod - 1)
    },

    endDate() {
      return dateToString(this.endDateObject)
    },

    cols() {
      const cols = []
      let dateObject = this.beginDateObject
      while(isEqualOrBefore(dateObject, this.endDateObject)) {
        const date = dateToString(dateObject)
        const dayOfWeek = (dateObject.getDay() + 6) % 7 // 月=0, 火=1, 水=2, 木=3, 金=4, 土=5, 日=6
        cols.push({
          date,
          timeIndex: date in this.holidays ? 7 : dayOfWeek, // 祝=7
          textMonth: dateFilter(dateObject, 'M'),
          textDate:  dateFilter(dateObject, 'd'),
          textWeek:  dateFilter(dateObject, 'E'),
          style:     {color: weeks[dayOfWeek].color},
        })
        dateObject = addDays(dateObject, 1)
      }
      return cols
    },

    rows() {
      // people: 個人ごと最新の個人日次データ
      const people = {}
      for(const dailyPerson of Object.values(this.dailyPeople)) {
        if(!(dailyPerson.person_code in people) ||
           people[dailyPerson.person_code].date < dailyPerson.date) {
          people[dailyPerson.person_code] = dailyPerson
        }
      }

      // 個人ごとの勤務時間の代表値を見つけて people に上書きする
      const dailyPeopleTime = {}
      for(const dailyPerson of Object.values(this.dailyPeople)) {
        if(timeIsValid(dailyPerson.begin_time, dailyPerson.end_time) &&
           (!(dailyPerson.person_code in dailyPeopleTime) ||
            dailyPerson.date < dailyPeopleTime[dailyPerson.person_code].date)) {
          dailyPeopleTime[dailyPerson.person_code] = dailyPerson
        }
      }

      for(const dailyPerson of Object.values(dailyPeopleTime)) {
        people[dailyPerson.person_code] = new DailyPerson({
          ...people[dailyPerson.person_code],
          begin_time: dailyPerson.begin_time,
          end_time:   dailyPerson.end_time,
        })
      }

      // 個人マスターから people に無いものを足す
      for(const person of Object.values(this.people)) {
        if(!(person.person_code in people)) {
          people[person.person_code] = person
        }
      }

      // rowと空のcellを作る
      const rows = Person.sort(people).map(person => ({

        person_code: person.person_code,
        name:        person.name,
        begin_time:  person.begin_time,
        end_time:    person.end_time,

        text:     person.label,
        textTime: person.timeLabel || '-',

        cells: this.cols.map(col => ({

          date:               col.date,
          id:                 null,
          regular_begin_time: null,
          regular_end_time:   null,

          text: STATUS_OFF,
        })),
      }))

      // cellを埋める
      const rowIndices = rows.reduce((a, v, i) => ({...a, [v.person_code]: i}), {})
      const colIndices = this.cols.reduce((a, v, i) => ({...a, [v.date]: i}), {})
      for(const dailyPerson of Object.values(this.dailyPeople)) {
        const irow = rowIndices[dailyPerson.person_code]
        if(irow != null) {
          const icol = colIndices[dailyPerson.date]
          if(icol != null) {
            const cell = rows[irow].cells[icol]
            cell.id                 = dailyPerson.id
            cell.regular_begin_time = dailyPerson.regular_begin_time
            cell.regular_end_time   = dailyPerson.regular_end_time

            if(dailyPerson.isTimeValid) {
              if(dailyPerson.regular_begin_time === dailyPerson.begin_time &&
                 dailyPerson.regular_end_time   === dailyPerson.end_time) {
                cell.text = STATUS_REGULAR
              }
              else {
                cell.text = STATUS_IRREGULAR
                cell.style = {backgroundColor: STATUS_IRREGULAR_COLOR}
              }
            }
            else if(dailyPerson.isRegularTimeValid) {
              cell.text = STATUS_IRREGULAR_OFF
              cell.style = {backgroundColor: STATUS_IRREGULAR_COLOR}
            }
            else {
              cell.text = STATUS_OFF
            }
          }
        }
      }

      return rows
    },
  },

  watch: {
    viewKey() {
      this.refresh()
    },

  },

  mounted() {
    this.refresh()
  },

  methods: {

    async refresh() {
      try {
        if(this.viewKey != null) {

          // 表示を一旦クリアする
          this.people = []
          this.dailyPeople = []
          this.grid.cursor = {x: 0, y: 0}

          //
          const [
            {data: people},
            {data: dailyPeople},
          ] = await Promise.all([
            this.axios.get('/api/people/' + this.storeCode + '/' + this.floorCode),
            this.axios.get('/api/daily_people/' + this.viewKey + '/' + this.endDate),
          ])
          this.people = people.reduce((a, v) => ({...a, [v.person_code]: new Person(v)}), {})
          this.dailyPeople = dailyPeople.reduce((a, v) => ({...a, [v.id]: new DailyPerson(v)}), {})
        }
      }
      catch(e) {this.$handler(e)}
    },

    async createDailyPerson(data) {
      ({data} = await this.axios.post('/api/daily_people', {
        store_code: this.storeCode,
        floor_code: this.floorCode,
        ...data,
      }))
      this.$set(this.dailyPeople, data.id, new DailyPerson(data))
    },

    async updateDailyPerson(data) {
      const orig = this.dailyPeople[data.id]
      const diff = Object.entries(data).reduce((a, [k, v]) => ({...a, ...v !== orig[k] ? {[k]: v} : {}}), {})
      if(Object.keys(diff).length !== 0) {
        await this.axios.put('/api/daily_people/' + data.id, diff)
        this.$set(this.dailyPeople, data.id, new DailyPerson({...orig, ...diff}))
      }
    },

    async updateCell(x, y, begin_time, end_time) {
      const row = this.rows[y]
      if(row != null) {
        const cell = row.cells[x]
        if(cell.id == null) {
          await this.createDailyPerson({
            date:        cell.date,
            person_code: row.person_code,
            name:        row.name,
            begin_time,
            end_time,
          })
        }
        else {
          await this.updateDailyPerson({
            id: cell.id,
            begin_time,
            end_time,
          })
        }
      }
    },

    //-------------------------------------------------------------------------
    // 基本マウスイベント

    onMouseDownLeft(e) {
      // ドラッグでグリッドのスクロールを行う
      this.beginDragScroll(e)
    },

    onCellMouseDownLeft(e) {
      // クリックでセルの選択を行う
      this.selectCell(e)
      // ドラッグでグリッドのスクロールを行う
      this.beginDragScroll(e)
    },

    onHeaderDoubleClick(e) {
      // 列ヘッダをダブルクリックで該当日時のレジシフト画面へ遷移
      const {x} = this.getCellPosition(e)
      const col = this.cols[x]
      this.$store.commit('route', {name: 'shifts', params: {date: col.date}})
    },

    //-------------------------------------------------------------------------
    // 基本キーボードイベント

    onKeyDown(e) {
      // デフォルトのキーイベント処理 矢印,Tab,Enter,Escに対応
      if(this.processKeyDown(e)) {
        return
      }

      // Backspace/Deleteキーでセルの削除
      if(e.key === 'Backspace' || e.key === 'Delete') {
        if(!this.isEditing) {
          this.timeRangeConfirm('', '', this.grid.cursor)
          e.preventDefault()
        }
        return
      }
    },

    //-------------------------------------------------------------------------
    // 出勤時刻,退勤時刻の編集 (cell領域をダブルクリック)

    onCellDoubleClick(e) {
      // セル領域をダブルクリックでセルの選択を行う
      this.selectCell(e)
      // セル領域をダブルクリックで出退勤時間の編集
      this.timeRangeShow()
    },

    // Enterキー押下による編集の開始
    onPressEnterBeginEdit() {
      this.timeRangeShow()
    },

    // cell領域コンテキストメニューによる編集の開始
    onCellContext(e, options) {
      this.selectCell(e)
      options([{
        label: '編集', onClick: () => {
          this.timeRangeShow()
        },
      }])
    },

    //
    timeRangeShow() {
      const {x, y} = this.grid.cursor
      const row = this.rows[y]
      if(row != null) {
        const cell = row.cells[x]
        const dailyPerson = this.dailyPeople[cell.id]

        let begin_time
        let end_time
        if(dailyPerson != null && dailyPerson.isTimeValid) {
          begin_time = dailyPerson.begin_time
          end_time   = dailyPerson.end_time
        }
        else if(timeIsValid(cell.regular_begin_time, cell.regular_end_time)) {
          begin_time = cell.regular_begin_time
          end_time   = cell.regular_end_time
        }

        this.$refs.popupTimeRange.show(begin_time, end_time, {x, y,
          title: row.text + ' ' + dateFilter(cell.date),
          regular: timeIsValid(cell.regular_begin_time, cell.regular_end_time)
            ? {begin: cell.regular_begin_time, end: cell.regular_end_time}
            : null,
        })
      }
    },

    timeRangeRegular() {
      const {x, y} = this.grid.cursor
      const row = this.rows[y]
      if(row != null) {
        const cell = row.cells[x]

        this.timeRangeConfirm(cell.regular_begin_time, cell.regular_end_time, {x, y})
      }
    },

    timeRangeOff() {
      this.timeRangeConfirm('', '', this.grid.cursor)
    },

    async timeRangeConfirm(begin_time, end_time, {x, y}) {
      try {
        await this.updateCell(x, y, begin_time, end_time)
        this.$refs.popupTimeRange.hide()
      }
      catch(e) {this.$handler(e)}
    },

    //-------------------------------------------------------------------------
    // 個人勤務予定表

    onRowHeaderContext(e, options) {
      options([{
        label: '個人勤務予定表', onClick: () => {
          const {y} = this.getCellPosition(e)
          const row = this.rows[y]
          const person = this.people[row.person_code]
          this.$refs.popupSchedule.show(person)
        },
      }])
    },

    //-------------------------------------------------------------------------

    // 初期化
    async onClickMakeDailies() {
      try {
        if(this.storeCode && this.floorCode && this.beginDate) {
          await this.$q.dialog({
            title:   '稼働計画およびレジシフトの初期化：' + dateFilter(this.beginDate) + '〜' + dateFilter(this.endDate),
            message: 'この期間の稼働計画およびレジシフトをすべて初期化します。本当によろしいですか？',
            ok:      {label: '実行',       color: 'negative'},
            cancel:  {label: 'キャンセル', color: 'dark', flat: true},
          })

          await this.axios.put('/api/dailies/' + this.storeCode + '/' + this.floorCode + '/' +  this.beginDate + '/' +  this.endDate + '/make')

          this.refresh()
          await this.$q.dialog({
            title:   '完了',
            message: '稼働計画の初期化が完了しました。',
            ok:      'OK',
          })
        }
      }
      catch(e) {this.$handler(e)}
    },

    // 印刷
    onClickPrint() {
      window.open('/api/dailies/' + this.storeCode + '/' + this.floorCode + '/' +  this.beginDate + '/' + this.endDate + '/print')
    },

  },
}
</script>

<style lang="sass">

$cellW:     25px
$headerA_H: 25px

.dailies__week--holiday
  position: relative

.dailies__week--holiday::before
  border: solid 1px red
  border-radius: 50%
  content: ""
  height: $headerA_H - 7px
  left: 3px + ($cellW - $headerA_H) / 2
  position: absolute
  top: 3px
  width: $headerA_H - 7px

</style>
